var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component } from 'vue-property-decorator';
var FilterCollectionMixin = /** @class */ (function (_super) {
    __extends(FilterCollectionMixin, _super);
    function FilterCollectionMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeFilters = {};
        return _this;
    }
    Object.defineProperty(FilterCollectionMixin.prototype, "isAnyFilterActive", {
        get: function () {
            return Object.keys(this.activeFilters).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    FilterCollectionMixin.prototype.onFilterBecomeActive = function (fieldName) {
        this.$set(this.activeFilters, fieldName, true);
    };
    FilterCollectionMixin.prototype.onFilterBecomeInactive = function (fieldName) {
        this.$delete(this.activeFilters, fieldName);
    };
    FilterCollectionMixin = __decorate([
        Component
    ], FilterCollectionMixin);
    return FilterCollectionMixin;
}(Vue));
export default FilterCollectionMixin;
